import { MakeCall, MakeCallPromise } from 'ha/services/apiV2/createMakeCall';
import { UserInfoApiV2, MyUserInfoApiV2 } from './types/UserInfo';
import { APIV2_URL } from './constants';

interface Query {
  expand: string;
}

const getUserInformation = (makeCall: MakeCall) => {
  function getUserInformationCall(
    id: 'me',
    query?: Query,
  ): MakeCallPromise<MyUserInfoApiV2>;
  function getUserInformationCall(
    id: number,
    query?: Query,
  ): MakeCallPromise<UserInfoApiV2>;
  function getUserInformationCall(id: number | 'me' = 'me', query?: Query) {
    return makeCall('GET', `${APIV2_URL}/user/${id}/information`, { query });
  }
  return getUserInformationCall;
};

export default getUserInformation;
